import * as z from 'zod'

export const TypologyFormSchema = z.object({
  id: z.number().optional(),
  type: z.string().nonempty('Selecione o tipo de tipologia.'),
  private_area: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  total_units: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  bedrooms: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  bathrooms: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  suites: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  parking: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  condominium_value: z
    .number({
      required_error: 'O campo é obrigatório.',
      invalid_type_error: 'O campo deve ser preenchido.',
    })
    .optional(),
  urban_land_tax: z
    .number({
      required_error: 'O campo é obrigatório.',
      invalid_type_error: 'O campo deve ser preenchido.',
    })
    .optional(),
  id_real_estate_launches: z.number().optional(),
  stock: z.number().optional(),
  sales: z.number().optional(),
})

export type TypologyFormData = z.infer<typeof TypologyFormSchema>

export const TypologyUpdateFormSchema = z.object({
  id: z.number().optional(),
  type: z.string().nonempty('Selecione o tipo de tipologia.'),
  private_area: z
    .number({
      required_error: 'O campo é obrigatório.',
      invalid_type_error: 'O campo deve ser preenchido.',
    })
    .min(1, {message: 'O valor deve ser pelo menos 1.'}) // Adiciona a validação de valor mínimo
    .optional(),
  total_units: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  bedrooms: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  bathrooms: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  suites: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  parking: z.number({
    required_error: 'O campo é obrigatório.',
    invalid_type_error: 'O campo deve ser preenchido.',
  }),
  condominium_value: z
    .number({
      required_error: 'O campo é obrigatório.',
      invalid_type_error: 'O campo deve ser preenchido.',
    })
    .optional(),
  urban_land_tax: z
    .number({
      required_error: 'O campo é obrigatório.',
      invalid_type_error: 'O campo deve ser preenchido.',
    })
    .optional(),
  id_real_estate_launches: z.number().optional(),
  stock: z.number().optional(),
  sales: z.number().optional(),
})

export type TypologyUpdateFormData = z.infer<typeof TypologyUpdateFormSchema>

// Schema com campos obrigatórios e validação de números
export const RealEstateLaunchSchema = z.object({
  name: z.string().min(2, 'O campo é obrigatório'),
  type: z.string().min(2, 'O campo é obrigatório'),
  number_of_towers: z.coerce.number().int().nullable().optional(),
  number_of_floors: z.coerce.number().int().nullable().optional(),
  apts_per_floor: z.coerce.number().int().nullable().optional(),
  finality: z.string().min(1, 'O campo é obrigatório'),
  total_units: z.number().int().positive('O campo deve ser um número positivo.'),
  status: z.string().min(1, 'O campo é obrigatório'),
  id_status: z.number().int().positive('O campo deve ser um número positivo.'),
  id_developer: z.number().int().positive('O campo deve ser um número positivo.'),
  launch_date: z.string().min(1, 'O campo é obrigatório'),
  opening_date: z.string().min(1, 'O campo é obrigatório'),
  future_launch: z.number().optional(),
  address: z.string().min(2, 'O campo é obrigatório'),
  zipcode: z.string().min(8, 'O campo é obrigatório'),
  id_state: z.number().int().positive('Selecione um Estado.'),
  id_city: z.number().int().positive('Selecione uma Cidade.'),
  neighborhood: z.string().min(2, 'O campo é obrigatório'),
  number: z.string().min(1, 'O campo é obrigatório'),
  latitude: z.number().optional(),
  longitude: z.number().optional(),
  complement: z.string().nullish().optional(),
  features: z.array(z.string()).optional(),
  floor_area: z.union([z.number().int().positive().min(1), z.number().nullish()]).optional(),
  total_area: z.number().optional().nullable(),
  description: z.string().optional().nullable(),
  notary_registration_number: z.string().nullish().optional(),
  webpage: z.string().optional().nullable(),
  opening_months: z.union([z.number().int().positive(), z.number().nullish()]).optional(),
  affordable_program: z.number().optional(),
  editado_urbit: z.number().optional(),
  observacoes_editado_urbit: z.string().optional(),
  origem: z.string().optional(),
})

// Definição do esquema para arquivos
export const FilesSchema = z.array(z.any()).optional()
// Exemplo de como combinar os esquemas se necessário
// export const CombinedSchema = z.object(RealEstateLaunchSchema);
export type RealEstateLaunchFormData = z.infer<typeof RealEstateLaunchSchema>
export type RealEstateLaunchFilesFormData = z.infer<typeof FilesSchema>
